<template>
    <div>
        <h1 class="title step-title">
            {{ $t('step-1.title') }}
        </h1>
        <div class="grid grid-card-square">
            <card-square
                v-for="{ id, icon, name } in catalog.applications"
                :key="id"
                :id="id"
                :title="name[locale]"
                :icon="icon"
            >
            </card-square>
        </div>
        <div class="flex justify-center mt-12 xxl:mt-16">
            <button
                class="btn btn-primary"
                @click="next('current-type')"
                :class="{ disabled: buttonIsDisabled }"
            >
            {{ $t('next') }}
            </button>
        </div>
    </div>
</template>

<script>
import CardSquare from "../cards/CardSquare.vue";
import { GETTERS } from "../../../store/wizard/types";
import { mapGetters } from "vuex";
import next from "../../../mixins/next";

export default {
    mixins: [next],

    components: {
        CardSquare
    },

    computed: {
        ...mapGetters({
            catalog: GETTERS.GET_CATALOG,
            consult: GETTERS.GET_CONSULT
        }),
        buttonIsDisabled() {
            return this.consult.applications.length === 0;
        },
        locale() {
            return this.$route.params.locale; 
        },
    }
};
</script>
